import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { DynamicEntryComponent, DynamicEntryComponentCrmConfig, DynamicOptionsComponent } from '../dynamic-options';

export interface Option {
  label: string;
  value: string;
}

@Component({
  template: '',
  standalone: true,
})
export abstract class StaticStringSelectComponent implements OnInit, DynamicOptionsComponent, DynamicEntryComponent {
  @Input() initialValue: string;
  @Input() showVariableItemMenu: boolean;
  @Input() label: string;
  @Input() required = false;
  @Input() config: DynamicEntryComponentCrmConfig;
  selectInputControl: UntypedFormControl;
  selectedValue$: Observable<any>;

  abstract options: Option[];

  ngOnInit(): void {
    this.selectInputControl = new UntypedFormControl(null, optionsValidatorBuilder(this.options));
    this.selectedValue$ = this.selectInputControl.valueChanges;

    if (this.initialValue !== null && this.initialValue !== undefined) {
      this.selectInputControl.setValue(this.initialValue + '');
    }
  }

  getSelectedValue(): string {
    return this.selectInputControl.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.selectInputControl];
  }

  isFormValid(): boolean {
    return this.selectInputControl.valid;
  }
}

function optionsValidatorBuilder(options: Option[]): (control: AbstractControl) => { [key: string]: any } {
  return (control: AbstractControl): { [key: string]: any } => {
    const option = (options || []).find((o) => o.value === control.value);
    if (!option) {
      return { invalid: true };
    }
  };
}

export abstract class StaticStringSelectDisplayService implements DataFilterDisplayService {
  abstract options: Option[];

  getDisplay(value: string): Observable<string> {
    const option = (this.options || []).find((o) => o.value === value + '');
    if (!option) {
      return of(`<b>${value}</b>`);
    }
    return of(`<b>${option?.label}</b>`);
  }
}
